define('SC.HorizonThemeExtension.Checkout', [
  'SC.HorizonThemeExtension.Header',
  'SC.HorizonThemeExtension.Footer',
  'SC.HorizonThemeExtension.Footer.Simplified',
  'SC.HorizonThemeExtension.ErrorManagement.PageNotFound.View',
  'SC.HorizonThemeExtension.Categories.Thumbnail',
  'SC.HorizonThemeExtension.ItemRelations.SC.Configuration',
  'SC.HorizonThemeExtension.GlobalViews.Breadcrumb.View',
  'SC.HorizonThemeExtension.LoginRegister.Login.View',
  'SC.HorizonThemeExtension.LoadWebFont',
  'SC.HorizonThemeExtension.Common.Configuration',
  'SC.HorizonThemeExtension.Common.LayoutHelper'
], function SCHorizonThemeExtensionCheckoutEntryPoint(
  HorizonThemeExtHeader,
  HorizonThemeExtFooter,
  HorizonThemeExtFooterSimplified,
  HorizonThemeExtErrorManagementPageNotFoundView,
  HorizonThemeExtCategoriesThumbnail,
  HorizonThemeExtItemRelations,
  HorizonThemeExtBreadcrumbView,
  HorizonThemeExtLoginRegister,
  HorizonThemeExtLoadWebFont,
  Configuration,
  LayoutHelper
) {
  'use strict';

  return {
    mountToApp: function (container) {
      Configuration.setEnvironment(container.getComponent('Environment'));
      LayoutHelper.setLayoutComponent(container.getComponent('Layout'));
      HorizonThemeExtHeader.loadModule();
      HorizonThemeExtFooter.loadModule();
      HorizonThemeExtFooterSimplified.loadModule();
      HorizonThemeExtErrorManagementPageNotFoundView.loadModule();
      HorizonThemeExtItemRelations.loadModule();
      HorizonThemeExtLoginRegister.loadModule();
      HorizonThemeExtLoadWebFont.loadModule();
    }
  };
});
